/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incrporated.
 */

import Cookie from 'js-cookie';

import Config from '../../config/Config';

export default async function ClearExternalUserCookies() {
  const path = '/';
  const domain = Config.getGatewayCookieDomain();
  const externalSessionCookieName = Config.getExternalSessionCookieName();
  return await Cookie.remove(externalSessionCookieName, { path, domain });
}
